var ALERTS_LIST_ACTIONS = {
  fetchAlertsList: 'FETCH_ALERTS_LIST',
  fetchingAlertsSucceeded: 'FETCHING_ALERTS_SUCCEEDED',
  fetchingAlertsFailed: 'FETCHING_ALERTS_FAILED',
  setTableOrder: 'SET_TABLE_ORDER',
  setFilters: 'SET_FILTERS',
  loadMoreRows: 'LOAD_MORE_ROWS',
  loadMoreRowsSucceeded: 'LOAD_MORE_ROWS_SUCCEEDED',
  loadMoreRowsFailed: 'LOAD_MORE_ROWS_FAILED'
};
export default ALERTS_LIST_ACTIONS;